function MFRBannerType1(index, element) {
  this.$element = $(element)

  this.selectors = {
    slider: '.slider',
    loader: '#banner-type-1-loading',
  }

  this.init()
}

MFRBannerType1.prototype = Object.assign({}, MFRBannerType1.prototype, {
  init: function () {
    this.$slider = this.$element.find(this.selectors.slider)
    
    $(document).on("ready", this.__handleSliderInit.bind(this))
    $(window).on("resize", this.__handleSliderInit.bind(this))

    $(document).on('open.zf.reveal', this.__handleBannerOpenEvent(this))
    $(document).on('closed.zf.reveal', this.__handleBannerClosedEvent(this))
  },

  __handleSliderInit: function() {
    let options = {
      pageDots: true,
      prevNextButtons: false
    }

    if (matchMedia('screen and (min-width: 1024px)').matches) {
      options.prevNextButtons = true;
    }

    this.$slider.flickity(options);
    window.flickityButtonArrowChange();
  },

  __handleBannerOpenEvent: function(event) {
    const $iframe = $(event.current).find('iframe')

    if ( $iframe.length > 0 ) {
      const player = new Vimeo.Player($iframe)
      player.play()
    }
  },

  __handleBannerClosedEvent: function(event) {
    const $iframe = $(event.current).find('iframe')

    if ( $iframe.length > 0 ) {
      const player = new Vimeo.Player($iframe)
      player.pause()
    }
  }
})